import React from "react";

export const SectionHeader = ({ overline, title, subtitle, align = "left", light = false }) => {
  const alignCls = align === "center" ? "text-center mx-auto" : "text-left";
  const titleColor = light ? "text-white" : "text-[#0A1F44]";
  const subColor = light ? "text-[#D8D3C4]" : "text-[#5C5C5C]";
  const overlineColor = light ? "text-[#D4AF37]" : "text-[#C9A227]";
  return (
    <div className={`max-w-3xl ${alignCls}`}>
      {overline && <div className={`overline ${overlineColor} mb-3`}>{overline}</div>}
      <h2
        className={`font-serif-display font-semibold ${titleColor} text-4xl sm:text-5xl leading-[1.05]`}
      >
        {title}
      </h2>
      {subtitle && (
        <p className={`mt-5 text-base leading-relaxed ${subColor}`}>{subtitle}</p>
      )}
      <div className={`mt-6 h-[2px] w-14 bg-[#D4AF37] ${align === "center" ? "mx-auto" : ""}`} />
    </div>
  );
};

export default SectionHeader;
